import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Form, Row, Select } from "antd";
import type { SourcingRequirementApplicationFormFields } from "../type";
import { factoryOptions } from "@/constants/requirementManagement";
import { ProductionMaterialFormFields } from "./ProductionMaterialFormFields";
import { NonProductionMaterialFormFields } from "./NonProductionMaterialFormFields";
import { useSourcingTypeQuery } from "../hooks/useSourcingTypeQuery";
import { useWatchProductionMaterial } from "../hooks/useWatchProductionMaterial";
import { useCostCenterOptions } from "@/hooks/services/useSelectOptionsQuery";
import styles from "@/asserts/styles/formSection.module.less";

export function SourcingRequirementFormFields() {
  const { isProductionMaterial, sourcingType } = useWatchProductionMaterial();
  const form = Form.useFormInstance<SourcingRequirementApplicationFormFields>();

  const { sourcingTypeOptions, getSubSourcingTypeOptions } =
    useSourcingTypeQuery();

  const factoryValue = Form.useWatch("factoryValue", form);
  const costCenterOptions = useCostCenterOptions(factoryValue);

  const onSourcingTypeChange = (value: string) => {
    // 当寻源类别变更时，重置寻源子类别
    form.setFieldsValue({
      subSourcingType: null,
      materialList: [{}],
    });

    // value === 1 为生产物料
    if (value === "1") {
      form.setFieldsValue({
        standardMaterialFiles: [],
        coaFiles: [],
      });
    } else {
      form.setFieldsValue({
        ursFiles: [],
        costCenter: "",
      });
    }
  };

  const subSourcingTypeOptions = getSubSourcingTypeOptions(sourcingType);

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="寻源信息" />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<SourcingRequirementApplicationFormFields>
              name="factoryValue"
              label="工厂"
              rules={[
                {
                  required: true,
                  message: "请选择工厂",
                },
              ]}
            >
              <Select options={factoryOptions} placeholder="请选择"></Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<SourcingRequirementApplicationFormFields>
              name="sourcingType"
              label="寻源类别"
              rules={[
                {
                  required: true,
                  message: "请选择寻源类别",
                },
              ]}
            >
              <Select
                options={sourcingTypeOptions}
                placeholder="请选择"
                onChange={(value) => onSourcingTypeChange(value)}
              ></Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<SourcingRequirementApplicationFormFields>
              name="subSourcingType"
              label="寻源二级类别"
              rules={[
                {
                  required: true,
                  message: "请选择二级寻源类别",
                },
              ]}
            >
              <Select
                options={subSourcingTypeOptions}
                placeholder="请选择"
              ></Select>
            </Form.Item>
          </Col>

          {!isProductionMaterial && (
            <Col span={8}>
              <Form.Item<SourcingRequirementApplicationFormFields>
                name="costCenter"
                label="成本中心"
                rules={[
                  {
                    required: true,
                    message: "请选择成本中心",
                  },
                ]}
              >
                <Select
                  options={costCenterOptions}
                  placeholder="请选择"
                  showSearch
                  optionFilterProp="label"
                ></Select>
              </Form.Item>
            </Col>
          )}
        </Row>

        {isProductionMaterial ? (
          <ProductionMaterialFormFields />
        ) : (
          <NonProductionMaterialFormFields />
        )}
      </div>
    </div>
  );
}
